// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".breadcrumbs ol li{margin-bottom:0.75rem;display:inline-block;font-family:VNPolarisWeb, Arial Narrow, sans-serif;font-size:0.875rem}.breadcrumbs ol li:after{padding-left:0.25rem;padding-right:0.25rem;font-size:1.125rem;content:\"»\";color:var(--category-color)}.breadcrumbs ol li:last-child:after{display:none}.breadcrumbs ol li a{--tw-text-opacity:1;color:rgb(34 41 47 / var(--tw-text-opacity))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
